export default __webpack_public_path__ + "images/45e44e1b107fbc2f810299382fc8434f-halloween_collections_touchpoint_image.webp";